(function () {
  document.querySelectorAll('[data-mgv-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (btn.tagName === 'A') e.preventDefault();
      document.querySelectorAll('.mgv-panel.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      var p = document.querySelector('[data-mgv-panel="' + btn.getAttribute('data-mgv-open') + '"]');
      if (!p) return;
      p.classList.add('is-open');
      var i = p.querySelector('input'); if (i) setTimeout(function () { i.focus(); }, 50);
    });
  });
  document.querySelectorAll('[data-mgv-close]').forEach(function (b) {
    b.addEventListener('click', function () { b.closest('.mgv-panel').classList.remove('is-open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.mgv-panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
  });

  var g = document.querySelector('[data-mgv-gallery]');
  if (g) {
    var slides = g.querySelectorAll('[data-slide]'), dots = g.querySelectorAll('[data-dot]'), thumbs = g.querySelectorAll('[data-thumb]');
    var cur = 0, touched = 0, paused = false, num = null;
    var show = function (i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
      dots.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
      thumbs.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
      if (num) num.textContent = (cur + 1) + ' / ' + slides.length;
    };
    var go = function (i) { touched = Date.now(); show(i); };
    var arrow = function (d) { return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
    var count = document.createElement('div');
    count.className = 'mgv-count';
    count.innerHTML = '<button type="button" aria-label="Photo précédente">' + arrow('M15 5l-7 7 7 7') + '</button><span aria-live="polite"></span><button type="button" aria-label="Photo suivante">' + arrow('M9 5l7 7-7 7') + '</button>';
    g.querySelector('.mgv-gal__main').insertAdjacentElement('afterend', count);
    num = count.querySelector('span');
    num.textContent = '1 / ' + slides.length;
    count.querySelectorAll('button')[0].addEventListener('click', function () { go(cur - 1); });
    count.querySelectorAll('button')[1].addEventListener('click', function () { go(cur + 1); });
    var sx = null;
    g.querySelector('.mgv-gal__main').addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    g.querySelector('.mgv-gal__main').addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
    });
    g.querySelector('[data-prev]').addEventListener('click', function () { go(cur - 1); });
    g.querySelector('[data-next]').addEventListener('click', function () { go(cur + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-thumb')); }); });
    var main = g.querySelector('.mgv-gal__main');
    main.addEventListener('mouseenter', function () { paused = true; });
    main.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () { if (!paused && Date.now() - touched > 6000) show(cur + 1); }, 3500);
  }

  var eta = document.querySelector('[data-mgv-eta]');
  if (eta) {
    var f = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }); };
    eta.innerHTML = 'Recevez-le entre le <strong>' + f(2) + '</strong> et le <strong>' + f(4) + '</strong>.';
  }

  /* Le formulaire de commande est désormais le formulaire natif EasySell (voir #es-form-hook). */

  var dataEl = document.getElementById('mgv-reviews-data');
  if (dataEl) {
    var R = JSON.parse(dataEl.textContent), rv = 0, rtouch = 0, rpaused = false, mi = 0;
    var mq = window.matchMedia('(max-width: 900px)');
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
    var track = document.querySelector('[data-track]'), rdots = document.querySelector('[data-rdots]');
    var mini = document.querySelector('[data-mgv-mini]');
    var card = function (r) {
      return '<article class="mgv-rcard"><span style="color:#E8B400;letter-spacing:2px;font-size:17px" aria-label="5 étoiles sur 5">★★★★★</span>' +
        '<p dir="auto">' + esc(r.t) + '</p><footer><i>' + esc(r.n.charAt(0)) + '</i><span><strong style="font-size:14px">' + esc(r.n) + '</strong><small>' + esc(r.c) + '</small></span></footer></article>';
    };
    var drawDots = function (i) {
      if (rdots) rdots.innerHTML = R.map(function (x, k) { return '<span class="' + (k === i ? 'is-on' : '') + '"></span>'; }).join('');
    };
    var showMini = function (i) {
      if (!mini) return;
      var r = R[i];
      mini.querySelector('[data-i]').textContent = r.n.charAt(0);
      mini.querySelector('[data-t]').textContent = '« ' + r.t + ' »';
      mini.querySelector('[data-n]').textContent = r.n + (r.c ? ' · ' + r.c : '');
    };
    var render = function () {
      if (track) {
        /* ordinateur : 3 avis à la fois ; téléphone / tablette : tous les avis sur une seule ligne à faire glisser */
        var n = mq.matches ? R.length : 3, h = '';
        for (var k = 0; k < n; k++) h += card(R[(rv + k) % R.length]);
        track.innerHTML = h;
        if (mq.matches) track.scrollLeft = 0;
      }
      drawDots(rv);
      showMini(rv);
    };
    var rgo = function (i) { rtouch = Date.now(); rv = (i + R.length) % R.length; render(); };
    var box = document.querySelector('[data-mgv-reviews]');
    if (box) {
      box.querySelector('[data-prev]').addEventListener('click', function () { rgo(rv - 1); });
      box.querySelector('[data-next]').addEventListener('click', function () { rgo(rv + 1); });
      box.addEventListener('mouseenter', function () { rpaused = true; });
      box.addEventListener('mouseleave', function () { rpaused = false; });
    }
    if (track) {
      track.addEventListener('scroll', function () {
        if (!mq.matches) return;
        var c = track.firstElementChild; if (!c) return;
        var i = Math.min(R.length - 1, Math.max(0, Math.round(track.scrollLeft / (c.offsetWidth + 12))));
        if (i !== rv) { rv = i; drawDots(rv); }
      }, { passive: true });
    }
    render();
    if (mq.addEventListener) mq.addEventListener('change', function () { rv = 0; render(); });
    setInterval(function () {
      if (mq.matches) { mi = (mi + 1) % R.length; showMini(mi); return; }
      if (!rpaused && Date.now() - rtouch > 7000) { rv = (rv + 1) % R.length; render(); }
    }, 4000);
  }
})();